import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';
import { CreditCardContext } from '../context/CreditCardContext';
import { withSelectedOrder, withTotalPayment } from '../utils';
import { BalanceContext } from '../context/BalanceContext';

declare let RETURN_URL: string;
declare let PAYMENT_GW_URL: string;
declare let COMPANY_ID: string;

const companyId = parseInt(COMPANY_ID);

export const PaymentGWPage = () => {
  const { token } = useContext(AuthContext);
  const { creditCard, ccValues, instalment } = useContext(CreditCardContext);
  const { balances, balancesSelection } = useContext(BalanceContext);
  const selectedBalances = withSelectedOrder(
    balances || [],
    balancesSelection || [],
  );
  const totalPayment = withTotalPayment(selectedBalances);
  const ref = useRef<HTMLFormElement>(null);

  // auto submit form
  useEffect(() => {
    ref.current?.submit();
  }, [ref]);

  return (
    <form action={PAYMENT_GW_URL} method="POST" ref={ref}>
      <input type="hidden" name="authToken" value={token} />
      {selectedBalances.map((bal, i) => (
        <React.Fragment key={bal.orderNumber}>
          <input
            type="hidden"
            name={`orders[${i}].orderNumber`}
            value={bal.orderNumber}
          />
          <input
            type="hidden"
            name={`orders[${i}].firstName`}
            value={bal.firstName}
          />
          <input
            type="hidden"
            name={`orders[${i}].lastName`}
            value={bal.lastName}
          />
          <input
            type="hidden"
            name={`orders[${i}].salesIndividualId`}
            value={String(bal.salesIndividualId)}
          />
          <input type="hidden" name={`orders[${i}].pnr`} value={bal.pnr} />
          <input
            type="hidden"
            name={`orders[${i}].amount`}
            value={Math.ceil(bal.payment.toPay.amount * 100) / 100}
          />
          <input
            type="hidden"
            name={`loyaltyPayment[${i}].salesIndividualId`}
            value={String(bal.salesIndividualId)}
          />
          <input
            type="hidden"
            name={`loyaltyPayment[${i}].amount`}
            value={bal.payment.loyalty.points}
          />
        </React.Fragment>
      ))}

      <input
        type="hidden"
        name="currencyId"
        value={creditCard?.information.currencyId}
      />
      <input
        type="hidden"
        name="currencyCode"
        value={creditCard?.information.currencyCode}
      />
      <input type="hidden" name="total" value={totalPayment.amount} />
      <input type="hidden" name="ccHolderName" value={ccValues?.ccHolderName} />
      <input type="hidden" name="ccNo" value={ccValues?.ccNo} />
      <input
        type="hidden"
        name="expiryMonth"
        value={ccValues?.expiry?.slice(0, 2)}
      />
      <input
        type="hidden"
        name="expiryYear"
        value={ccValues?.expiry?.slice(2)}
      />
      <input type="hidden" name="cvv" value={ccValues?.cvv} />

      <input
        type="hidden"
        name="provider"
        value={creditCard?.information.provider}
      />
      <input
        type="hidden"
        name="cardType"
        value={creditCard?.information.cardType}
      />
      <input
        type="hidden"
        name="cardProgram"
        value={creditCard?.information.cardProgram}
      />
      <input
        type="hidden"
        name="cardScheme"
        value={creditCard?.information.cardScheme}
      />
      <input type="hidden" name="vposBankId" value={instalment?.vposBankId} />
      <input type="hidden" name="instalments" value={instalment?.count} />
      <input type="hidden" name="returnUrl" value={RETURN_URL} />
      <input type="hidden" name="companyId" value={companyId} />
    </form>
  );
};
